import { Skeleton } from "@/components/ui/skeleton";
import { label, tone } from "@/lib/format";

export const Badge = ({ s, testid }) => (
  <span data-testid={testid} className={`inline-flex items-center whitespace-nowrap rounded-full px-2.5 py-0.5 text-xs font-semibold ${tone(s)}`}>{label(s)}</span>
);

export const PageHeader = ({ title, subtitle, children }) => (
  <div className="mb-6 flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
    <div>
      <h1 data-testid="page-title" className="text-2xl font-bold tracking-tight text-[#12343B] md:text-3xl">{title}</h1>
      {subtitle && <p className="mt-1 max-w-2xl text-sm text-[#587178]">{subtitle}</p>}
    </div>
    {children && <div className="flex flex-wrap gap-2">{children}</div>}
  </div>
);

export const Kpi = ({ icon: Icon, label: l, value, hint, accent, testid }) => (
  <div data-testid={testid} className="card-soft p-5 transition-transform duration-300 hover:-translate-y-0.5">
    <div className="flex items-center justify-between">
      <p className="text-sm font-medium text-[#587178]">{l}</p>
      {Icon && <span className={`flex h-9 w-9 items-center justify-center rounded-xl ${accent ? "bg-[#00FF40]" : "bg-[#81D8D0]/25"}`}><Icon className="h-4 w-4 text-[#12343B]" /></span>}
    </div>
    <p className="mt-3 text-2xl font-bold text-[#12343B]">{value}</p>
    {hint && <p className="mt-1 text-xs text-[#587178]">{hint}</p>}
  </div>
);

export const Empty = ({ text = "Nenhum registro ainda." }) => (
  <div data-testid="empty-state" className="card-soft flex flex-col items-center justify-center p-10 text-center text-sm text-[#587178]">
    <span className="mb-3 flex h-12 w-12 items-center justify-center rounded-full bg-[#E3FAF7] text-xl font-bold text-[#2a8f86]">n.</span>{text}
  </div>
);

export const Loading = ({ rows = 4 }) => (
  <div className="space-y-3" data-testid="loading">{Array.from({ length: rows }).map((_, i) => <Skeleton key={i} className="h-16 w-full rounded-2xl" />)}</div>
);

export const Notice = ({ children, kind = "info" }) => (
  <div className={`mb-5 rounded-2xl p-4 text-sm ${kind === "warn" ? "bg-[#FEF3C7] text-[#92400E]" : "bg-[#E0F2FE] text-[#075985]"}`}>{children}</div>
);
